export const translations = {
  bs: {
    nav: { products: "Proizvodi", about: "O nama", news: "Novosti", showroom: "Salon", cta: "Kontaktirajte nas" },
    trust: [
      { key: "quality", title: "VRHUNSKI KVALITET", desc: "Proizvodi provjerenih evropskih proizvođača." },
      { key: "ages", title: "ZA SVE UZRASTE", desc: "Rješenja za djecu, odrasle i starije." },
      { key: "life", title: "STVORENO ZA ŽIVOT", desc: "Udobnost, sigurnost i samostalnost u fokusu." },
      { key: "support", title: "STRUČNA PODRŠKA", desc: "Tu smo da pronađemo pravo rješenje za vas." },
    ],
    hero: {
      overline: "MOBIX",
      lines: ["PRECIZNOST", "JE U POKRETU"],
      subtitle:
        "Vrhunska invalidska kolica i rješenja za mobilnost za svaku životnu dob.",
      ctaPrimary: "Istražite proizvode",
      ctaSecondary: "Kontaktirajte nas",
      scroll: "Skrolaj",
      categories: [
        { key: "manual", label: "Manuelna\ninvalidska kolica" },
        { key: "powered", label: "Električna\ninvalidska kolica" },
        { key: "homecare", label: "Kućna\nnjega" },
        { key: "rehab", label: "Rehabilitacijska\noprema" },
      ],
      cards: [
        { key: "manual", label: "Ručna invalidska kolica" },
        { key: "powered", label: "Električna invalidska kolica" },
        { key: "bathroom", label: "Stolice za kupanje i tuširanje" },
        { key: "beds", label: "Električni kreveti" },
        { key: "aids", label: "Pomagala za kretanje" },
      ],
    },
    marquee: "PRECIZNOST JE U POKRETU",
    products: {
      title: "Proizvodi",
      heading: "RJEŠENJA ZA SVAKU POTREBU",
      subtitle:
        "Svaki proizvod pažljivo biramo prema kvaliteti, sigurnosti i udobnosti — za odrasle i djecu.",
      viewAll: "Prikaži sve",
      viewAllDesc: "Istražite našu kompletnu ponudu rješenja za mobilnost.",
      allTitle: "SVI PROIZVODI",
      backHome: "Nazad na početnu",
      requestInfo: "Zatražite informacije",
      modelsLabel: "Modeli",
      exploreLabel: "Pogledaj modele",
      comingSoonKicker: "Uskoro",
      comingSoon: "Nova kolekcija uskoro",
      comingSoonDesc: "Pripremamo novu kolekciju proizvoda. Ostavite nam kontakt i javit ćemo vam se čim bude dostupna.",
      notify: "Obavijesti me kada bude dostupno",
      cards: [
        { key: "manual", name: "Ručna invalidska kolica", desc: "Lagana i izdržljiva kolica za svakodnevnu neovisnost.", items: [
          { id: "lite-100", name: "MOBIX Lite 100", desc: "Lagana svakodnevna kolica, jednostavna za sklapanje i prijenos." },
          { id: "active-x2", name: "MOBIX Active X2", desc: "Aktivna kolica niske težine za dinamičan svakodnevni život." },
          { id: "comfort-plus", name: "MOBIX Comfort Plus", desc: "Dodatna podstavljenost i podrška za dužu udobnost." },
        ]},
        { key: "powered", name: "Električna invalidska kolica", desc: "Precizno upravljanje i pouzdan domet, uz maksimalnu udobnost.", items: [
          { id: "volt-e1", name: "MOBIX Volt E1", desc: "Kompaktna električna kolica idealna za unutrašnje prostore." },
          { id: "cruise-e3", name: "MOBIX Cruise E3", desc: "Veći domet baterije za samostalna putovanja u gradu." },
          { id: "terra-x", name: "MOBIX Terra X", desc: "Robusna kolica za sve terene i vanjsku upotrebu." },
        ]},
        { key: "bathroom", name: "Stolice za kupanje i tuširanje", desc: "Sigurne, vodootporne stolice za dostojanstvenu njegu.", items: [
          { id: "aqua-chair", name: "MOBIX Aqua Chair", desc: "Stolica za tuširanje protiv klizanja s podesivom visinom." },
          { id: "aqua-commode", name: "MOBIX Aqua Commode", desc: "Kombinovana toaletno-tuš stolica za punu njegu." },
          { id: "bath-bench", name: "MOBIX Bath Bench", desc: "Stabilna klupa za sigurno presjedanje u kadi." },
        ]},
        { key: "beds", name: "Električni kreveti", desc: "Podesivi kreveti za udoban odmor i lakšu njegu kod kuće.", items: [
          { id: "rest-3f", name: "MOBIX Rest 3F", desc: "Električni krevet s 3 funkcije za udoban odmor." },
          { id: "care-4f", name: "MOBIX Care 4F", desc: "Krevet za kućnu njegu s 4 funkcije i bočnim ogradama." },
          { id: "bariatric-plus", name: "MOBIX Bariatric Plus", desc: "Ojačani krevet povećane nosivosti i širine." },
        ]},
        { key: "aids", name: "Pomagala za kretanje", desc: "Štake, hodalice i pomagala za sigurno kretanje.", items: [
          { id: "walk-rollator", name: "MOBIX Walk Rollator", desc: "Hodalica na 4 točka s kočnicama i sjedalom." },
          { id: "step-walker", name: "MOBIX Step Walker", desc: "Sklopiva hodalica lagana za prijenos i skladištenje." },
          { id: "grip-crutches", name: "MOBIX Grip Crutches", desc: "Ergonomske štake s udobnim rukohvatom." },
        ]},
      ],
    },
    about: {
      overline: "O MOBIX-u",
      title1: "PRECIZNOST NIJE OPCIJA.",
      title2: "TO JE NAŠ ",
      titleAccent: "STANDARD",
      paragraph:
        "Svako rješenje za mobilnost pažljivo biramo kako bi zadovoljilo najviše standarde kvalitete, sigurnosti i udobnosti — pomažući ljudima da se kreću s više samopouzdanja, svaki dan.",
      steps: [
        { title: "BIRAMO", desc: "Pažljivo biramo rješenja za mobilnost od provjerenih proizvođača koji zadovoljavaju naše visoke standarde." },
        { title: "PROVJERAVAMO", desc: "Svaki proizvod temeljito ocjenjujemo po sigurnosti, kvaliteti i trajnosti prije nego postane dio ponude." },
        { title: "DOSTAVLJAMO", desc: "Osiguravamo brzu i pouzdanu dostavu kako biste dobili pravo rješenje točno kada vam treba." },
        { title: "VI SE KREĆETE", desc: "Jer prava mobilnost znači neovisnost, samopouzdanje i slobodu u svakodnevnom životu." },
      ],
    },
    news: {
      overline: "NOVOSTI",
      title: "OSTANITE INFORMISANI",
      subtitle: "Najnovije vijesti, uvidi i inovacije iz svijeta mobilnosti.",
      viewAll: "Sve novosti",
      readMore: "Pročitaj više",
      items: [
        { key: "government", category: "VLADA", date: "10. JUL 2026.", title: "Vlada preispituje mjere podrške osobama s invaliditetom u Federaciji BiH", desc: "Nadležni preispituju mjere za poboljšanje socijalne zaštite i finansijske podrške osobama s invaliditetom, s fokusom na jednak pristup uslugama i dugoročnu inkluziju." },
        { key: "policy", category: "POLITIKE", date: "3. DECEMBAR 2025.", title: "BiH potvrđuje opredijeljenost za inkluziju osoba s invaliditetom", desc: "Na Međunarodni dan osoba s invaliditetom, institucije širom Bosne i Hercegovine potvrdile su opredijeljenost za provođenje inkluzivnih politika i poboljšanje pristupačnosti." },
        { key: "community", category: "ZAJEDNICA", date: "25. JUN 2026.", title: "Organizacije osoba s invaliditetom nastavljaju zagovaranje jednakih prava", desc: "Organizacije osoba s invaliditetom širom zemlje nastavljaju saradnju s javnim institucijama na unapređenju pristupačnosti, mogućnosti zapošljavanja i samostalnog života." },
        { key: "veterans", category: "VETERANI", date: "18. JUN 2026.", title: "Organizacije za podršku veteranima šire programe rehabilitacije", desc: "Organizacije koje podržavaju ratne vojne invalide i amputirce šire programe rehabilitacije, psihološke podrške i inicijative za samostalnu mobilnost širom BiH." },
        { key: "social", category: "SOCIJALNA ZAŠTITA", date: "30. MAJ 2026.", title: "Regionalni penzioni i invalidski fondovi o unapređenju saradnje", desc: "Predstavnici Bosne i Hercegovine i susjednih zemalja razgovarali su o zakonskim izmjenama, digitalnim uslugama i poboljšanjima u sistemima invalidske i penzione zaštite." },
      ],
    },
    showroom: {
      overline: "SALON",
      words: ["POGLEDAJTE", "DODIRNITE", "ISPROBAJTE"],
      paragraph1: "Odabir pravog rješenja za mobilnost je lična odluka i iskustvo.",
      paragraph2: "Posjetite naš salon kako biste istražili proizvode, uporedili različite modele i dobili stručno vođenje prilagođeno vašim potrebama.",
      viewMap: "Prikaži na karti",
      captions: ["Sjedište Mobix", "Salon", "Ured", "Recepcija"],
    },
    contact: {
      overline: "KONTAKT",
      title: "POKRET POČINJE OVDJE",
      subtitle: "Svaki pokret počinje pravom odlukom. Svako veliko rješenje kreće jednostavnim razgovorom.",
      name: "Ime i prezime",
      email: "Email adresa",
      phone: "Telefon (opcionalno)",
      message: "Vaša poruka",
      submit: "Pošalji poruku",
      sending: "Slanje...",
      success: "Hvala! Vaša poruka je uspješno poslana.",
      error: "Došlo je do greške. Pokušajte ponovo.",
      addressLabel: "Adresa",
      address: "Mala Aleja 67, 71210 Ilidža, Bosna i Hercegovina",
      emailLabel: "E-MAIL",
      emailValue: "info@mobix.ba",
      phoneLabel: "TELEFON",
      phoneValue: "+387 60 323 6229",
      disclaimer: "Slanjem ovog obrasca pristajete da vas MOBIX kontaktira u vezi s vašim upitom.",
    },
    footer: {
      tagline: "Preciznost je u pokretu.",
      nav: "Navigacija",
      contact: "Kontakt",
      rights: "Sva prava zadržana.",
    },
    chat: { label: "Chat", title: "Razgovarajmo" },
  },
  en: {
    nav: { products: "Products", about: "About Us", news: "News", showroom: "Showroom", cta: "Contact us" },
    trust: [
      { key: "quality", title: "PREMIUM QUALITY", desc: "Products from trusted European manufacturers." },
      { key: "ages", title: "FOR ALL AGES", desc: "Solutions for children, adults and seniors." },
      { key: "life", title: "DESIGNED FOR LIFE", desc: "Comfort, safety and independence in focus." },
      { key: "support", title: "EXPERT SUPPORT", desc: "We're here to help you find the right solution." },
    ],
    hero: {
      overline: "MOBIX",
      lines: ["PRECISION", "IN MOTION"],
      subtitle:
        "Premium wheelchairs and mobility solutions for every stage of life.",
      ctaPrimary: "Explore Products",
      ctaSecondary: "Contact Us",
      scroll: "Scroll",
      categories: [
        { key: "manual", label: "Manual\nWheelchairs" },
        { key: "powered", label: "Powered\nWheelchairs" },
        { key: "homecare", label: "Home\nCare" },
        { key: "rehab", label: "Rehabilitation\nEquipment" },
      ],
      cards: [
        { key: "manual", label: "Manual Wheelchairs" },
        { key: "powered", label: "Powered Wheelchairs" },
        { key: "bathroom", label: "Bath & Shower Chairs" },
        { key: "beds", label: "Electric Beds" },
        { key: "aids", label: "Mobility Aids" },
      ],
    },
    marquee: "PRECISION IN MOTION",
    products: {
      title: "Products",
      heading: "SOLUTIONS FOR EVERY NEED",
      subtitle:
        "Every product is carefully selected for quality, safety and comfort — for adults and children alike.",
      viewAll: "View All",
      viewAllDesc: "Explore our complete range of mobility solutions.",
      allTitle: "ALL PRODUCTS",
      backHome: "Back to home",
      requestInfo: "Request information",
      modelsLabel: "Models",
      exploreLabel: "View models",
      comingSoonKicker: "Coming soon",
      comingSoon: "New collection coming soon",
      comingSoonDesc: "We are preparing a new collection of products. Leave us your details and we'll let you know as soon as it's available.",
      notify: "Notify me when available",
      cards: [
        { key: "manual", name: "Manual Wheelchairs", desc: "Lightweight, durable chairs for everyday independence.", items: [
          { id: "lite-100", name: "MOBIX Lite 100", desc: "Lightweight everyday chair, easy to fold and transport." },
          { id: "active-x2", name: "MOBIX Active X2", desc: "Low-weight active chair for a dynamic daily life." },
          { id: "comfort-plus", name: "MOBIX Comfort Plus", desc: "Extra padding and support for longer-lasting comfort." },
        ]},
        { key: "powered", name: "Powered Wheelchairs", desc: "Precise control and dependable range, in total comfort.", items: [
          { id: "volt-e1", name: "MOBIX Volt E1", desc: "Compact electric chair ideal for indoor spaces." },
          { id: "cruise-e3", name: "MOBIX Cruise E3", desc: "Extended battery range for independent city trips." },
          { id: "terra-x", name: "MOBIX Terra X", desc: "Rugged all-terrain chair for outdoor use." },
        ]},
        { key: "bathroom", name: "Bath & Shower Chairs", desc: "Safe, water-resistant chairs for dignified care.", items: [
          { id: "aqua-chair", name: "MOBIX Aqua Chair", desc: "Anti-slip shower chair with adjustable height." },
          { id: "aqua-commode", name: "MOBIX Aqua Commode", desc: "Combined commode and shower chair for full care." },
          { id: "bath-bench", name: "MOBIX Bath Bench", desc: "Stable bench for safe transfers in the bathtub." },
        ]},
        { key: "beds", name: "Electric Beds", desc: "Adjustable beds for restful comfort and easier home care.", items: [
          { id: "rest-3f", name: "MOBIX Rest 3F", desc: "3-function electric bed for restful comfort." },
          { id: "care-4f", name: "MOBIX Care 4F", desc: "4-function homecare bed with side rails." },
          { id: "bariatric-plus", name: "MOBIX Bariatric Plus", desc: "Reinforced bed with increased capacity and width." },
        ]},
        { key: "aids", name: "Mobility Aids", desc: "Crutches, walkers and aids for safe, confident movement.", items: [
          { id: "walk-rollator", name: "MOBIX Walk Rollator", desc: "4-wheel rollator with brakes and a seat." },
          { id: "step-walker", name: "MOBIX Step Walker", desc: "Folding walker, light to carry and store." },
          { id: "grip-crutches", name: "MOBIX Grip Crutches", desc: "Ergonomic crutches with a comfortable grip." },
        ]},
      ],
    },
    about: {
      overline: "ABOUT MOBIX",
      title1: "PRECISION IS NOT A FEATURE.",
      title2: "IT'S OUR ",
      titleAccent: "STANDARD",
      paragraph:
        "Every mobility solution we offer is carefully selected to meet the highest standards of quality, safety and comfort — helping people move with greater confidence, every day.",
      steps: [
        { title: "WE SELECT", desc: "We carefully choose mobility solutions from trusted manufacturers that meet our high standards." },
        { title: "WE VERIFY", desc: "Every product is thoroughly evaluated for safety, quality and durability before it becomes part of our range." },
        { title: "WE DELIVER", desc: "We ensure fast, reliable delivery so you get the right solution, exactly when you need it." },
        { title: "YOU MOVE", desc: "Because true mobility means independence, confidence and freedom in everyday life." },
      ],
    },
    news: {
      overline: "NEWS",
      title: "STAY INFORMED",
      subtitle: "The latest updates, insights and innovations from the world of mobility.",
      viewAll: "View All News",
      readMore: "Read more",
      items: [
        { key: "government", category: "GOVERNMENT", date: "JULY 10, 2026", title: "Government Reviews Disability Support Measures in the Federation of BiH", desc: "Authorities are reviewing measures to improve social protection and financial support for people with disabilities, focusing on equal access to services and long-term inclusion." },
        { key: "policy", category: "POLICY", date: "DECEMBER 3, 2025", title: "Bosnia Reaffirms Commitment to Disability Inclusion", desc: "On the International Day of Persons with Disabilities, institutions across Bosnia and Herzegovina reiterated their commitment to implementing inclusive policies and improving accessibility nationwide." },
        { key: "community", category: "COMMUNITY", date: "JUNE 25, 2026", title: "National Disability Organisations Continue Advocacy for Equal Rights", desc: "Disability organisations across the country continue working with public institutions to advance accessibility, employment opportunities and independent living for all." },
        { key: "veterans", category: "VETERANS", date: "JUNE 18, 2026", title: "Veteran Support Organisations Expand Rehabilitation Programs", desc: "Organisations supporting disabled veterans and amputees are expanding rehabilitation, psychological support and independent mobility initiatives throughout Bosnia and Herzegovina." },
        { key: "social", category: "SOCIAL SECURITY", date: "MAY 30, 2026", title: "Regional Pension and Disability Funds Meet to Improve Cooperation", desc: "Representatives from Bosnia and Herzegovina and neighbouring countries discussed legislative updates, digital services and improvements in disability and pension systems." },
      ],
    },
    showroom: {
      overline: "SHOWROOM",
      words: ["SEE", "TOUCH", "TRY"],
      paragraph1: "Choosing the right mobility solution is a personal decision and experience.",
      paragraph2: "Visit our showroom to explore our products, compare different models and receive expert guidance tailored to your needs.",
      viewMap: "View on Map",
      captions: ["Mobix HQ", "Showroom", "Office", "Reception"],
    },
    contact: {
      overline: "CONTACT US",
      title: "THE MOTION STARTS HERE",
      subtitle: "Every movement begins with the right decision. Every great solution starts with a simple conversation.",
      name: "Full name",
      email: "Email address",
      phone: "Phone (optional)",
      message: "Your message",
      submit: "Send message",
      sending: "Sending...",
      success: "Thank you! Your message has been sent.",
      error: "Something went wrong. Please try again.",
      addressLabel: "Address",
      address: "Mala Aleja 67, 71210 Ilidža, Bosnia and Herzegovina",
      emailLabel: "E-MAIL",
      emailValue: "info@mobix.ba",
      phoneLabel: "PHONE",
      phoneValue: "+387 60 323 6229",
      disclaimer: "By submitting this form, you agree to be contacted by MOBIX regarding your request.",
    },
    footer: {
      tagline: "Precision in motion.",
      nav: "Navigation",
      contact: "Contact",
      rights: "All rights reserved.",
    },
    chat: { label: "Chat", title: "Chat with us" },
  },
};
